var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColteneLogoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.006,
    height: 23.348,
    viewBox: "0 0 32.006 23.348",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "coltene_logo_mobile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(-912 -263.323)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M7.428,11.3,2.22,22.274H9.063l5.2-10.974Z",
    transform: "translate(912.445 264.397)",
    fill: "#00a4e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M14.629,11.3,9.42,22.274h6.843l5.2-10.974Z",
    transform: "translate(913.892 264.397)",
    fill: "#57c1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M21.83,11.3,16.621,22.274h6.843L28.67,11.3Z",
    transform: "translate(915.336 264.397)",
    fill: "#acdefa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M5.209.8,0,11.772H6.843L12.047.8Z",
    transform: "translate(912 262.525)",
    fill: "#0090df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M12.409.8,7.2,11.772h6.843L19.248.8Z",
    transform: "translate(913.447 262.525)",
    fill: "#0090df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M19.611.8,14.4,11.772h6.843L26.45.8Z",
    transform: "translate(914.891 262.525)",
    fill: "#0090df"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColteneLogoMobile);
export default __webpack_public_path__ + "static/media/coltene_logo_mobile.23301648526a625ae814fbde1337f5b2.svg";
export { ForwardRef as ReactComponent };